import React from 'react';
import { HOME_GAME_CARDS, type HomeGameScreen } from '@/data/homeGameCards';
import { wgChromeMin } from './playTogetherPanelTokens';

type Lang = 'en' | 'es';

interface PlayTogetherGameCardsGridProps {
  lang: Lang;
  onPickGame: (id: HomeGameScreen) => void;
  /** Tile matching the practice path (e.g. literacy → Animal ABCs); visually emphasized, all tiles still shown */
  highlightedGameId?: HomeGameScreen;
  highlightBadge?: { en: string; es: string };
}

const PlayTogetherGameCardsGrid: React.FC<PlayTogetherGameCardsGridProps> = ({
  lang,
  onPickGame,
  highlightedGameId,
  highlightBadge,
}) => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gap: '10px',
      marginTop: '12px',
    }}
  >
    {HOME_GAME_CARDS.map((card) => {
      const isHighlight = highlightedGameId === card.id;
      return (
        <button
          key={card.id}
          type="button"
          onClick={() => onPickGame(card.id)}
          style={{
            position: 'relative',
            border: isHighlight ? '3px solid #FEF9C3' : 'none',
            borderRadius: '16px',
            padding: '12px 10px',
            cursor: 'pointer',
            textAlign: 'left',
            background: card.color,
            color: '#fff',
            boxShadow: isHighlight
              ? '0 0 0 2px #166534, 0 8px 22px rgba(22,101,52,0.35)'
              : '0 4px 14px rgba(0,0,0,0.12)',
            transition: 'transform 0.15s ease, box-shadow 0.15s ease',
            minHeight: '108px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            gap: '6px',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.02)';
            e.currentTarget.style.boxShadow = isHighlight
              ? '0 0 0 2px #166534, 0 10px 26px rgba(22,101,52,0.4)'
              : '0 6px 18px rgba(0,0,0,0.18)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = isHighlight
              ? '0 0 0 2px #166534, 0 8px 22px rgba(22,101,52,0.35)'
              : '0 4px 14px rgba(0,0,0,0.12)';
          }}
          aria-current={isHighlight ? true : undefined}
        >
          {isHighlight && highlightBadge && (
            <span
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                fontSize: '11px',
                fontWeight: 800,
                letterSpacing: '0.02em',
                textTransform: 'uppercase',
                background: 'rgba(255,255,255,0.95)',
                color: '#14532D',
                padding: '4px 8px',
                borderRadius: '8px',
                lineHeight: 1,
              }}
            >
              {highlightBadge[lang]}
            </span>
          )}
          <span style={{ fontSize: '1.35rem' }}>{card.emoji}</span>
          <span style={{ fontWeight: 800, fontSize: '18px', lineHeight: 1.25 }}>
            {card.title[lang]}
          </span>
          <span
            style={{
              fontSize: wgChromeMin,
              opacity: 0.95,
              lineHeight: 1.4,
              fontWeight: 600,
            }}
          >
            {card.description[lang]}
          </span>
        </button>
      );
    })}
  </div>
);

export default PlayTogetherGameCardsGrid;
